// ----------------------------------------------------------------------------
// Template: Search
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/pagination/pagination';
import 'snippets/search-form/search';
import 'sections/header/header';
import 'sections/page-header/page-header';
import 'sections/footer/footer';

// Styles
import './_search.scss';

import { openModal, closeModal, triggerModal } from 'snippets/_containers/modal/modal';

const SEARCH_TABS = document.querySelectorAll('.tablinks');
const MODAL_OPEN_BUTTON  = '.modal__trigger';
const MODAL_CLOSE_BUTTON = '.modal__close-button';
const MODAL_OVERLAY      = '.modal__overlay';

SEARCH_TABS.forEach((tab) => {

    if (!tab.classList.contains('active')) {
        const tabType = tab.getAttribute('data-tab');

        // Get the full URL (pathname + search/query parameters)
        const url = new URL(window.location.href);  // Create URL object
        let tabSection = 'dynamic-tab--products';
        let resultsSection = 'main-content--search--product';
        let tempUrl = '';

        if (tabType === 'Products') {
            // Check if 'type' parameter exists in the query, if not, add or update it
            url.searchParams.set('type', 'product');
        } else {
            url.searchParams.set('type', 'article,page');
            tabSection = 'dynamic-tab--article-page';
            resultsSection = 'main-content--search--article-page';

            // Get all search parameters
            const params = url.searchParams;

            // Iterate over the parameters and remove those with "filter" in their name
            for (let param of params.keys()) {
                if (param.startsWith('filter')) {
                    params.delete(param);
                }
            }

            // Create the updated URL without filter parameters
            tempUrl = url.pathname + '?' + params.toString();
        }

        url.searchParams.set('page', '1'); // Reset page to 1 when changing tab

        // Build the new URL by combining pathname with updated query parameters
        let updatedUrl = url.pathname + url.search;

        if (tempUrl != '') {
            updatedUrl = tempUrl;
        }

        fetch(`${updatedUrl}&sections=${tabSection}`)
        .then(res => res.json())
        .then(data => {
            if (data && data[tabSection]) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data[tabSection], 'text/html');
                const button = doc.querySelector('.tablinks');
                tab.innerHTML = button.innerHTML;
            } else {
                console.log("No data for the 'dynamic-tab'.");
            }
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    tab.addEventListener('click', (e) => {
        e.preventDefault();

        const tabType = tab.getAttribute('data-tab');

        // Get the full URL (pathname + search/query parameters)
        const url = new URL(window.location.href);  // Create URL object
        let tabSection = 'dynamic-tab--products';
        let resultsSection = 'main-content--search--product';
        let tempUrl = '';

        url.searchParams.set('page', '1'); // Reset page to 1 when changing tab

        if (tabType === 'Products') {
            // Check if 'type' parameter exists in the query, if not, add or update it
            url.searchParams.set('type', 'product');
        } else {
            url.searchParams.set('type', 'article,page');
            tabSection = 'dynamic-tab--article-page';
            resultsSection = 'main-content--search--article-page';

            // Get all search parameters
            const params = url.searchParams;

            // Iterate over the parameters and remove those with "filter" in their name
            for (let param of params.keys()) {
                if (param.startsWith('filter')) {
                    params.delete(param);
                }
            }

            // Create the updated URL without filter parameters
            tempUrl = url.pathname + '?' + params.toString();
        }

        // Build the new URL by combining pathname with updated query parameters
        let updatedUrl = url.pathname + url.search;

        if (tempUrl != '') {
            updatedUrl = tempUrl;
        }

        if (!tab.classList.contains('active')) {
            document.querySelectorAll('.tablinks.active').forEach((tab) => {
                tab.classList.remove('active');
            });

            tab.classList.add('active');
        }

        fetch(`${updatedUrl}&sections=${resultsSection}`)
        .then(res => res.json())
        .then(data => {
            if (data && data[resultsSection]) {
                document.querySelector('.tabcontent').outerHTML = data[resultsSection];

                document.querySelectorAll(MODAL_OPEN_BUTTON).forEach((openButton) => {
                    openButton.addEventListener('click', triggerModal);
                });

                document.querySelectorAll(MODAL_CLOSE_BUTTON).forEach((closeButton) => {
                    closeButton.addEventListener('click', closeModal);
                });

                document.querySelector(MODAL_OVERLAY)?.addEventListener('click', closeModal);

                // Open modal on keypress
                document.querySelectorAll(MODAL_OPEN_BUTTON).forEach((openButton) => {
                    openButton.addEventListener('keypress', (event) => {
                        if (event.key === 'Enter') {
                            triggerModal(event);
                        }
                    });
                });
            } else {
                console.log("No data for the results section.");
            }
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    });
});
